import st from "@/styles/SignContract.module.scss";
import DashboardGenComponent from "@/components/DashboardGenComponent.tsx";
import { useTranslation } from "react-i18next";
import React, {useEffect, useRef, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import { useAtom } from "jotai/index";
import {
    contract_pg_nr, cr_line_contract,
    sign_contract_otp_interval,
    succeded_transaction
} from "@/atoms/common.ts";
import useLoans from "@/hooks/loans.ts";
import Button from "@/ui/Button.tsx";
import DashboardClass from "@/utils/dashboard_class.ts";
// import DownloadIcon from "@/svg/DownloadIcon.tsx";
import CMS from "@/utils/cms.ts";
import useAuth from "@/hooks/auth.ts";
import clsx from "clsx";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import {CircularProgress} from "@mui/material";
import CreditApplicationInterface from "@/types_and_interfaces/credit_application_interface.ts";
import useIntervals from "@/hooks/intervals.ts";
import { isMobile } from 'react-device-detect';
import CrLineTransactionInterface from "@/types_and_interfaces/cr_line_transaction_interface.ts";
// import SignTransactionContractOTP from "@/ui/modals/SignTransactionContractOTP.tsx";
// import GetContractModal from "@/ui/modals/GetContractModal.tsx";
import {LocalLanguage} from "@/types_and_interfaces/types.ts";
import SignTransactionContractOTPModal from "@/ui/modals/SignTransactionContractOTP.tsx";
import {strings} from "@/utils/strings.ts";


import { Document, Page, pdfjs as reactPdfjs } from 'react-pdf';
import * as pdfjsLib from "pdfjs-dist";
// import workerUrl from '@/pdf.worker.ts';
reactPdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.mjs';
const { getDocument } = pdfjsLib;

const SignCrLineContract = () => {
    const { t } = useTranslation();
    const [contract_loan, set_contract_loan] = useState<CrLineTransactionInterface | undefined>(undefined);
    const [open_otp_modal_loan, set_open_otp_modal_loan] = useState<CreditApplicationInterface | undefined>(undefined)
    const [pdf_js_success, set_pdf_js_success] = useState(false)
    const navigate = useNavigate();
    const effect_ran = useRef<boolean>(false);
    const loans = useLoans();
    const cr_line_loans = loans.getLoansByType("Credit Line")?.filter((x) => x.r_status === "approved")
    const transactions = (Array.isArray(cr_line_loans) && cr_line_loans.length) ?  loans.get_last_cr_line()?.transactions : []
    const [contract_atom, ] = useAtom(cr_line_contract);
    const [numPages, setNumPages] = useAtom(contract_pg_nr);
    const containerRef = useRef(null);
    const [scale, set_scale] = useState<number>(1)
    let initialDistance: number | null = null;
    const {loan_urn} = useParams()
    
    
    const otp_modal_loan_handler = (x:any) => {
        set_open_otp_modal_loan(x)
    }
    
    const handleDownload = () => {
        
        const link = document.createElement('a');
        link.href = contract_atom[contract_loan?.urn_tr || ""].value || "";
        link.download = strings.doc_name.replace("{{urn}}", contract_loan?.urn_tr || "");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
    };
    
    const getDistance = (touches:any) => {
        const [touch1, touch2] = touches;
        return Math.sqrt(
            (touch2.clientX - touch1.clientX) ** 2 +
            (touch2.clientY - touch1.clientY) ** 2
        );
    };
    
    const handleTouchStart = (e:any) => {
        if (e.touches.length === 2) {
            initialDistance = getDistance(e.touches);
        }
    };
    
    const handleTouchMove = (e:any) => {
        if (e.touches.length === 2 && initialDistance !== null) {
            const currentDistance = getDistance(e.touches);
            
            if (currentDistance > initialDistance) {
                set_scale((prevScale:number) => Math.min(prevScale + 1, 3));
            } else if (currentDistance < initialDistance) {
                set_scale((prevScale:number) => Math.max(prevScale - 1, 1));
            }
            
            initialDistance = currentDistance;
        }
    };
    
    
    useEffect(() => {
        if(cr_line_loans === undefined){
            loans.updateUserLoans()
        } else {
            
            let appl = (transactions as Array<CrLineTransactionInterface>).find((x:CrLineTransactionInterface) => x.urn_tr === loan_urn)
            
            if(typeof appl === "undefined"){
                navigate(DashboardClass.dashboard_routes.CreditLine);
                
            } else if(typeof appl === "object") {
                set_contract_loan(appl)
            }
        }
        
        
    }, [transactions]);
    
    useEffect(() => {
        const getContract = async () => {
            
            await loans.getTransactionContract({
                client_loan_id: contract_loan?.client_loan_id,
                urn: contract_loan?.urn_tr
            }, contract_loan?.urn_tr || "");
            
            await loans.readTransactionContract({
                client_loan_id: contract_loan?.client_loan_id,
                urn: contract_loan?.urn_tr
            })
        };
        
        
        if(!effect_ran.current && typeof contract_loan === "object" && Object.keys(contract_loan).length && !contract_atom.hasOwnProperty(contract_loan?.urn_tr)) {
            getContract();
            effect_ran.current = true
        }
        
    }, [contract_loan]);
    
    useEffect(() => {
        const fetchPdf = async () => {
            if (contract_atom.hasOwnProperty(contract_loan?.urn_tr || "") && contract_atom[contract_loan?.urn_tr || ""]?.value?.length && isMobile && numPages === 0) {
                try {
                    const loadingTask = getDocument(contract_atom[contract_loan?.urn_tr || ""]?.value);
                    const pdf = await loadingTask.promise;
                    setNumPages(pdf._pdfInfo.numPages);
                    
                } catch (err) {
                    console.error('Error loading PDF: ' + err);
                }
            }
        };
        
        fetchPdf();
        
    }, [contract_atom]);
    
    useEffect(() => {
        const container:any = containerRef.current;
        
        if(container){
            container.addEventListener('touchstart', handleTouchStart);
            container.addEventListener('touchmove', handleTouchMove);
        }
        
        return () => {
            
            // set_contract_atom(undefined)
            
            if(container){
                container.removeEventListener('touchstart', handleTouchStart);
                container.removeEventListener('touchmove', handleTouchMove);
            }
        };
    }, []);
    
    return (
        
        <>
            <DashboardGenComponent
                light_gray_bg
                responsive1
                center_expanded
                header_type={"primary"}
                onBackClick={() => {
                    navigate(DashboardClass.dashboard_routes.CreditLine);
                }}
                header_content={
                    <div className={st.header_content}>
                        {t("sign_contract_part")}
                    </div>
                }
                column_center={
                    <div className={st.column_center}>
                        <div ref={containerRef} className={st.cont}>
                            {(!contract_atom.hasOwnProperty(contract_loan?.urn_tr || "") || ( contract_atom.hasOwnProperty(contract_loan?.urn_tr || "") && contract_atom[contract_loan?.urn_tr || ""]?.value?.includes("error") )) ? (
                                <CircularProgress  color={"success"}/>
                            ) : (
                                <>
                                    {isMobile ? (
                                        <>
                                            
                                            {numPages > 0 ? (
                                                <Document
                                                    loading={
                                                        <div
                                                            style={{
                                                                width: "100%",
                                                                height: "500px",
                                                                display:"flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <CircularProgress color={"success"}/>
                                                        </div>
                                                    }
                                                    renderMode={"canvas"}
                                                    className={st.pdf_view}
                                                    file={contract_atom[contract_loan?.urn_tr || ""]?.value}
                                                    onLoadSuccess={() => {
                                                        set_pdf_js_success(true)
                                                    }}
                                                >
                                                    {Array.from({ length: numPages }, (_, index) => (
                                                        <Page
                                                            key={`page_pdf_${index}`}
                                                            width={window.innerWidth - 32}
                                                            className={st.page}
                                                            renderTextLayer={false}
                                                            pageNumber={index + 1}
                                                            scale={scale}
                                                            renderAnnotationLayer={false}
                                                            loading={<CircularProgress color={"success"}/>}
                                                        />
                                                    ))}
                                                
                                                </Document>
                                            ) : <CircularProgress color={"success"}/>}
                                        
                                        </>
                                    ) : (
                                        <iframe
                                            src={contract_atom[contract_loan?.urn_tr || ""]?.value}
                                            title="PDF Viewer"
                                        />
                                    )}
                                
                                </>
                            )}
                        </div>
                        
                        {window.innerWidth <= 1540 && (
                            <div className={st.column_right_mobile}>
                                <Ticks
                                    sign_modal_handler={otp_modal_loan_handler}
                                    dwn={handleDownload}
                                    contract_loan={contract_loan}
                                    pdf_js_success={pdf_js_success}
                                />
                                {/*<Button onClick={handleDownload}>Download</Button>*/}
                            </div>
                        )}
                    </div>
                }
                column_right={window.innerWidth > 1540 ? (
                    <div className={st.column_right}>
                        <Ticks
                            contract_loan={contract_loan}
                            sign_modal_handler={otp_modal_loan_handler}
                            dwn={handleDownload}
                            pdf_js_success={pdf_js_success}
                        />
                        {/*<Button onClick={handleDownload}>Download</Button>*/}
                    </div>
                ) : <></>}
            />
            
            {/*<GetContractModal*/}
            {/*    line*/}
            {/*    credit={contract_loan}*/}
            {/*    contr={contract_atom}*/}
            {/*/>*/}
            
            <SignTransactionContractOTPModal
                data={open_otp_modal_loan}
                data_handler={otp_modal_loan_handler}
            />
        </>
    );
};


interface Props {
    dwn():void
    sign_modal_handler(x:any):void
    contract_loan:CrLineTransactionInterface | undefined
    pdf_js_success: boolean
}

const Ticks:React.FC<Props> = ({ /*dwn,*/ sign_modal_handler, contract_loan}) => {
    
    const {t, i18n} = useTranslation()
    const auth = useAuth()
    const user = auth.getProfile()
    const loans = useLoans()
    const agreements = CMS.sign_contract_agreements.list
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const [contract_atom] = useAtom(cr_line_contract);
    const intervals_hook = useIntervals(sign_contract_otp_interval)
    const [, set_succeded_application] = useAtom(succeded_transaction)
    
    const sign = async (e: any) => {
        e.preventDefault();

        if(!user?.phone.length) {
            eventEmitter.emit(CommonClass.ModalEvents.SetPhone, true, "", t("add_phone_to_continue"))
            return
        }
        
        const checkboxes = Array.from(document.querySelectorAll('input[type="checkbox"]'));
        const allChecked = checkboxes.every((checkbox: any) => checkbox.checked);
        
        checkboxes.forEach(checkbox => checkbox.classList.remove(st.error));
        
        if (!allChecked) {
            checkboxes.forEach(checkbox => checkbox.classList.add(st.error));
            eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "error", t("sign_err_error"))
            return;
        }
        
        if (typeof contract_loan === "object") {
            setLoading(true)
            
            // @ts-ignore
            if((typeof intervals_hook.getInterval() === "string" && intervals_hook.getInterval().length) || typeof intervals_hook.getInterval() !== "string") {
                sign_modal_handler(contract_loan)

            } else {
                
                
                const data = {
                    client_loan_id: contract_loan.client_loan_id,
                    urn: contract_loan.urn_tr,
                };
                
                const enabled = await loans.signTransactionContractSt1(data);
                
                if(typeof user !== undefined) {
                    
                    if(user?.auth_type === "ByMPass"){
                        
                        if (enabled) {
                            // clear_contract_blob(new Map());
                            set_succeded_application(contract_loan)
                            navigate(DashboardClass.dashboard_routes.Success);
                        }
                        
                    } else {
                        
                        intervals_hook.setIntervalHandler()
                        sign_modal_handler(contract_loan)
                        
                    }
                }
            }
            
            

            
            setLoading(false)
        }
    };
    
    return (
        <>
            
            <div className={st.agreements}>
                
                <form onSubmit={sign}>
                    
                    {agreements?.map((cont: any, i: number) => {
                        
                        let tempDiv = document.createElement('div');
                        const ct = CMS.langAwareFilter(cont, (i18n.language as LocalLanguage))
                        tempDiv.innerHTML = ct.agreement_content.includes("{{site_url}}") ? ct.agreement_content.replace("{{site_url}}", import.meta.env.VITE_WEBSITE_URL) : ct.agreement_content
                        
                        let links = tempDiv.querySelectorAll('a');
                        links.forEach(link => {
                            link.setAttribute('target', '_blank');
                        });
                        
                        let updatedAgreement = tempDiv.innerHTML;
                        
                        return (
                            <div key={`agreements_checkbox_${i}`} className={st.checkbox_cont}>
                                
                                <input
                                    className={clsx(st.checkbox)}
                                    type={"checkbox"}
                                    // ref={checkbox}
                                    name={`checkbox_${i}`}
                                    defaultChecked={false}
                                    color="success"
                                    onChange={() => {
                                        // if (!checkbox.current) return
                                        // checkbox.current.style.outline = 'none'
                                        // checkbox.current.style.borderRadius = '0'
                                    }}
                                
                                />
                                
                                {ct.agreement_content ? (
                                    <div className={st.content} dangerouslySetInnerHTML={{__html: updatedAgreement}}/>
                                ) : null}
                            
                            </div>
                        )
                    })}
                    
                    <Button disabled={loading || !contract_atom.hasOwnProperty(contract_loan?.urn_tr || "")} type={"submit"} className={st.sign}>
                        
                        {loading && <CircularProgress size={20} color={"inherit"}/>}
                        
                        {t("sign_contract")}
                    
                    </Button>
                
                </form>
            </div>
            
            {/*<Button*/}
            {/*    type={"button"}*/}
            {/*    onClick={dwn}*/}
            {/*    outlined*/}
            {/*    className={st.download_btn}*/}
            {/*    disabled={Boolean(contract_atom === undefined)}*/}
            {/*>*/}
            {/*    <>*/}
            {/*        <DownloadIcon/>*/}
            {/*        */}
            {/*        {t("dwn_contract")}*/}
            {/*    </>*/}
            
            {/*</Button>*/}
            
            {/*<div className={st.contract}>*/}
            {/*    <strong>*/}
            {/*        {t("contract")}*/}
            {/*    </strong>*/}
            {/*    */}
            {/*    <button*/}
            {/*        onClick={() => {*/}
            {/*            eventEmitter.emit(CommonClass.ModalEvents.OpenGetContractModal, contract_loan)*/}
            {/*        }}*/}
            {/*    >*/}
            {/*        {t("download_contract")}*/}
            {/*    </button>*/}
            
            {/*</div>*/}
        </>
    )
}


export default SignCrLineContract;
